module.exports = __webpack_public_path__ + "static/image3-ab7da8e74179aa79d79b58edd5f036d8.jpg";